import productAndBonusWhiteImg from "../../../assets/img/product-3-and-bonus-white.png";
import productAndBonusWhiteImgWebp from "../../../assets/img/product-3-and-bonus-white.webp";
import cardsImg from "../../../assets/img/cards.png";
import cardsImgWebp from "../../../assets/img/cards.webp";

const ActNow = () => (
    <section id="act-now">
        <div className="container-fluid gg-bg-solid-blue text-white">
            <div className="row justify-content-center align-content-center text-center py-3 gg-bg-solid-yellow-light text-black">
                <div className="col-xxl-5 col-xl-7 col-lg-8 col-11">
                    <h1 className="fw-bold">This Page Won’t Come Back</h1>
                </div>
            </div>
            <div className="row align-items-center justify-content-center pt-5">
                <div className="col-md-8 col-11 text-center">
                    <h5 className="mb-3">Once you close this page, this special offer will be gone for good.</h5>
                    <h5 className="mb-4">No emails. No pop-ups. No do-overs.</h5>
                    <h4 className="mb-5">
                        Don’t risk running out.<br />
                        Don’t interrupt your reset.<br />
                        Don’t pay more next time.
                    </h4>
                </div>
            </div>
            <div className="row align-items-center justify-content-center text-center mb-5">
                <div className="col-12">
                    <picture>
                        <source srcSet={productAndBonusWhiteImgWebp} type="image/webp" />
                        <img className="img-fluid" src={productAndBonusWhiteImg} loading="lazy" />
                    </picture>
                </div>
            </div>
            <div className="row justify-content-center text-center my-4">
                <div className="col-xxl-3 col-lg-4 col-md-6 col-sm-7 col-10 ">
                    <a href="https://buygoods.com/secure/upsell/?account_id=11273&product_codename=glu3d&redirect=aHR0cHM6Ly9nbHVjb2dlbjE3LmNvbS9iZy91ZC9vcHRpdmlzdGEtdQ==" className="text-decoration-none btn gg-button-buy-yellow gg-buy-card-button gg-bigger-button fs-5 fw-bold text-uppercase gtm-buy-btn" data-gtm-label="GlucoGen Downsell 3 - Act Now - Yes Button" data-gtm-product="glu3d" data-gtm-price="99">👉 YES! Upgrade My Order Now</a>
                </div>
            </div>
            <div className="row justify-content-center text-center pb-4">
                <div className="col-xxl-6 col-xl-7 col-lg-8 col-sm-10">
                    <div className=" mb-5">
                        <a href="https://buygoods.com/secure/upsell/?account_id=11273&product_codename=glu3d&redirect=aHR0cHM6Ly9nbHVjb2dlbjE3LmNvbS9iZy91ZC9vcHRpdmlzdGEtdQ==" className="text-white gtm-buy-btn" data-gtm-label="GlucoGen Downsell 3 - Act Now - Yes Link" data-gtm-product="glu3d" data-gtm-price="99">Click here to add 3 more bottles to your order at just $33 each and give your body the time it needs to finish the job.</a>
                    </div>
                    <a href="/bg/ud/optivista-u" className="text-white-50 gg-small-text gg-link gtm-no-ud-btn" data-gtm-label="GlucoGen Downsell 3 - Act Now - No Link" data-gtm-product="glu3d" data-gtm-price="99">No thanks, I’ll miss this final chance... I understand I will not have access to this price again, and I may run out before the real results begin.</a>
                    <div className="mt-4">
                        <picture>
                            <source srcSet={cardsImgWebp} type="image/webp" />
                            <img className="img-fluid gg-cards-max-height" src={cardsImg} loading="lazy" />
                        </picture>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default ActNow;